import React, { FC, ReactNode, MouseEvent } from "react";
import { Typography } from "../../../Fundamentals/Typography";
import { Button } from "../../Button";
import { ILinkProps } from "../../Link/Link";
import { Link } from "../../Link";

export interface IEmptyBrandSlide {
  text?: ReactNode;
  btnText?: ReactNode;
  link: ILinkProps<HTMLLinkElement>;
  onClick?: (e: MouseEvent) => void;
}

const EmptyBrandSlide: FC<IEmptyBrandSlide> = ({
  text = "brands you love",
  btnText = "view all",
  link,
  onClick,
}) => (
  <Link href={link.href} classes={{ root: "text-decoration-none" }}>
    <div className="d-flex flex-column bg-color-blue p-7 h-100">
      <Typography
        variant="h2-enriched"
        classes={{ root: "mb-0 text-color-white" }}
      >
        {text}
      </Typography>
      <Button
        classes={{ root: "mt-auto ms-0 me-auto" }}
        variant="secondary"
        size="small"
        onClick={onClick}
      >
        {btnText}
      </Button>
    </div>
  </Link>
);

export default EmptyBrandSlide;
